export default __webpack_public_path__ + "static/media/279.9789b224.jpg";